import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAuth, connectAuthEmulator } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBKnA2ZqIb2e8506SOiLtPoIGOHVGyyhL8",
  authDomain: "stuttgart-stage2-dev.firebaseapp.com",
  projectId: "stuttgart-stage2-dev",
  storageBucket: "stuttgart-stage2-dev.appspot.com",
  messagingSenderId: "123320483869",
  appId: "1:123320483869:web:ece0ea90ee1cc6e8ac06f4",
  measurementId: "G-PGPM98QVR3"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);

const useEmulators = process.env.REACT_APP_USE_EMULATORS === "1";

if (useEmulators) {
  console.log("🔥 Using Firebase EMULATORS");
  connectFirestoreEmulator(db, "127.0.0.1", 8085);
  connectAuthEmulator(auth, "http://127.0.0.1:9095");
} else {
  console.log("✅ Using LIVE Firebase");
}